import React, { Component } from 'react'
import NewMsgImg from '../../../../_assets/images/new-message.png'
import classNames from 'classnames'
import SendLinkModal from '../../../Messages/Components/SendLinkModal'
import SendMessageChatBox from '../../../Messages/Components/SendMessageChatBox'
import SendAttachmentModal from '../../../Messages/Components/SendAttachmentModal'

import { Button, Image } from 'react-bootstrap'
import { isValidURL } from '../../../../_helpers/regex'
import { alertActions } from '../../../../_actions/alert.actions'
import { Message, MessageModalCarePlan } from '@axshealth/design-library'

import moment from 'moment'
import Online from '../../../Messages/Stream/Components/Online'
import withDataService from './withDataService'
import RenderProfilePicture from '../../../../_helpers/profile-picture'

import './style.css'

class Messages extends Component {
  constructor(props) {
    super(props)

    this.state = {
      url: '',
      message: '',
      messages: props.messages || [],
      showFile: false,
      showLink: false,
      isSending: false,
      attachment: null,
      invalidURL: false,
      newMessage: false,
      showCarePlan: false,
      invalidAttachment: false,
      isStarting: false
    }

    this.handleURL = this.handleURL.bind(this)
    this.startVideo = this.startVideo.bind(this)
    this.handleMessage = this.handleMessage.bind(this)
    this.startTelehealth = this.startTelehealth.bind(this)
    this.handleAttachment = this.handleAttachment.bind(this)
    this.showHasNewMessage = this.showHasNewMessage.bind(this)
    this.handleScrollToBottom = this.handleScrollToBottom.bind(this)
  }

  componentDidMount() {
    this.scrollTimeout = setTimeout(() => {
      this.handleScrollToBottom()
    }, 2000)
  }

  componentWillUnmount() {
    clearTimeout(this.scrollTimeout)
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({
        messages: this.props.messages,
      }, () => {
        this.showHasNewMessage(prevProps)
      })
    }
  }

  showHasNewMessage(prevProps) {
    const messagesLen = prevProps.messages.length
    const messagesPropLen = this.state.messages.length

    if (
      messagesLen !== messagesPropLen &&
      messagesLen !== 0 &&
      messagesPropLen !== 0
    ) {
      const lastMessage = this.props.messages[0]
      if (lastMessage.sentBy.id !== this.props.currentUser.UserId) {
        this.observeLastMessage()
      } else {
        setTimeout(() => {
          this.handleScrollToBottom()
        }, 200);
      }
    }
  }

  observeLastMessage() {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        const lastMessageIsVisible = entries[0].isIntersecting
        this.setState({ newMessage: !lastMessageIsVisible })

        if (lastMessageIsVisible) {
          observer.unobserve(entries[0].target);
          this.handleScrollToBottom()
        }
      },
      { 
        root: document.getElementById('message-container'),
        rootMargin: '0px 0px 200px 0px'
      }
    )
    observer.observe(document.querySelector('#message-container > div > div'))
  }

  handleScrollToBottom() {
    const scrollTarget = document.getElementById('message-container')
    if (scrollTarget) {
      scrollTarget.scrollTo({
        top: scrollTarget.scrollHeight,
        behavior: 'smooth'
      })
    }
    this.setState({ newMessage: false })
  }

  handleAttachment() {
    if (!this.state.attachment) {
      this.setState({ invalidAttachment: true })
    } else {
      this.setState({ isSending: true, invalidAttachment: false })
      this.props.dispatch(alertActions.clear())

      this.props.sendAttachment(this.state.attachment[0])
        .catch(() => {
          this.props.dispatch(alertActions.error('Could not send file at this time. Please try again.'))
        })
        .then(() => {
          this.setState({ attachment: null, isSending: false, showFile: false })
        })
    }
  }

  handleURL() {
    this.setState({ invalidURL: false })

    if (!isValidURL(this.state.url)) {
      this.setState({ invalidURL: true })
    } else {
      this.setState({ isSending: true })
      this.props.dispatch(alertActions.clear())

      this.props.sendLink(this.state.url)
        .then(() => {
          this.setState({ url: '' })
        })
        .catch(() => {
          this.props.dispatch(alertActions.error('Could not send link at this time. Please try again.'))
        })
        .then(() => {
          this.setState({ isSending: false, showLink: false })
        });
    }
  }

  handleMessage() {
    this.setState({ isSending: true })

    this.props.dispatch(alertActions.clear())

    this.props.sendMessage(this.state.message)
      .then(() => {
        this.setState({ message: '' })
      })
      .catch(() => {
        this.props.dispatch(alertActions.error('Could not send message at this time. Please try again.'))
      })
      .then(() => {
        this.setState({ isSending: false })
      });
  }

  handleReadReceipt(message) {
    return (
      this.props.currentUser.UserId === message.sentBy.id && (
        <span>
          <span className='font-weight-bold px-2'>·</span>Sent
          {/* Patient Read <span className='text-success'>✔</span> */}
        </span>
      )
    )
  }

  startTelehealth () {
    this.setState({ isStarting: true})

    this.props.startTelehealth()
      .catch(() => {
        this.props.dispatch(alertActions.error('An error has ocurred starting the telehealth appointment. Please try again.'))
      })
      .then(() => {
        this.setState({ isStarting: false})
      })
  }

  startVideo() {
    if (this.props.telehealth.status === 'COMPLETED') {
      this.props.dispatch(alertActions.info('The telehealth appointment has ended.'))

      return
    }

    var myWidth = 1200
    var myHeight = 700
    var left = (window.screen.width - myWidth) / 2
    var top = (window.screen.height - myHeight) / 2
    window.open(`/telehealths/${this.props.telehealth.id}/video`, '', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${myWidth}, height=${myHeight}, top=${top}, left=${left}`)
  }

  render() {
    const { telehealth, currentUser } = this.props
    const { message, messages, showLink, showFile, showCarePlan, isSending } = this.state

    const sendBtnStatus = classNames({
      'btn-success': message !== '',
      'btn-secondary': message === '',
      'no-click-events': isSending || message === ''
    })

    const newMessageBtn = classNames(
      'new-message-btn axs-rounded shadow bg-primary text-light', {
      'new-message-btn-show': this.state.newMessage,
    })

    return <div className="card axs-shadow">
      <div className="d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
        {telehealth.settings.showOnline && this.props.online.map(user => {
          return <Online key={user.userId} user={user} />
        })}
      </div>

      { telehealth.status === 'HOLD' &&
        <div id='message-container' className='d-flex flex-column justify-content-around' style={{ height: '500px', padding: '0 15px' }}>
          <div>
            <div className="media pb-4">
              <div className="media-body">
                <p className="text-muted text-center m-0">
                  Let your patient know you'd like to start the telehealth appointment!
                </p>
              </div>
            </div>
            <div className='d-flex flex-column align-items-center py-4'>
              <div className="media">
                <RenderProfilePicture image={telehealth.userProfile.profile} circle cached={false} width={50} height={50} className='m-auto' />
                <div className="media-body ml-3">
                  <h5 className="m0-0">{`${telehealth.userProfile.firstName} ${telehealth.userProfile.lastName}`}</h5>
                  <span className="text-muted">{telehealth.userProfile.gender === 'm' ? 'Male' : 'Female'}, {moment(telehealth.userProfile.dateOfBirth).format('L')}</span>
                </div>
              </div>
            </div>
            <div className="media pt-4">
              <div className="media-body text-center">
                <Button variant='success' onClick={this.startTelehealth} disabled={this.state.isStarting}>{ this.state.isStarting ? <i className="fa fa-spinner fa-spin fa-fw"></i> : 'Start Telehealth Appointment' }</Button>
              </div>
            </div>
          </div>
        </div>
      }

      { telehealth.status === 'READY' && messages.length === 0 &&
      <div id='message-container' style={{ height: '500px', padding: '0 15px' }}>
        <div className="media pt-5 pb-4">
          <div className="media-body">
            <h5 className="text-muted text-center m-0">
            {telehealth.telemedicineType === 'video' ?
                `Start your real-time video with ${telehealth.userProfile.firstName} ${telehealth.userProfile.lastName}!`
                :
                `Say hello to ${telehealth.userProfile.firstName} ${telehealth.userProfile.lastName}!`
              }
            </h5>
          </div>
        </div>
        <div className="media">
          <div className="media-body text-center">
            <Image width={400} src={NewMsgImg} />
          </div>
        </div>
      </div>
      }

      { (telehealth.status === 'READY' || telehealth.status === 'COMPLETED' || telehealth.status === 'CANCELED') && messages.length > 0 &&
      <div id='message-container' style={{ height: '500px', padding: '0 15px' }}>
        <div className="d-flex flex-column-reverse">
          {messages.map((message, i) => {
            return <Message
              id={telehealth.id}
              key={message.message_id}
              message={message}
              currentUser={currentUser.UserId}
              showCarePlan={() => { this.setState({ showCarePlan: true }) }}
              handleClickLink={(url) => window.open(url, '_blank')}
              handleClickAttachment={(url) => window.open(url, '_blank')}
              startTelehealthVideo={this.startVideo}
            />
          })}
        </div>
      </div>
      }
      
      { (telehealth.status === 'COMPLETED' || telehealth.status === 'CANCELED') && messages.length === 0 &&
      <div className="media py-5">
        <div className="media-body text-center">
          No messages were sent during this telehealth appointment.
        </div>
      </div>
      }

      {telehealth.status === 'READY' &&
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className='d-flex justify-content-center'>
                <div onClick={this.handleScrollToBottom} className={newMessageBtn}>
                  <i className="fas fa-comment"></i>&nbsp;New Message
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 pt-3">
              <button onClick={(e) => {
                e.preventDefault()
                this.startVideo()
              }} className="btn btn-primary btn-block">Start Video</button>
            </div>

            <br />

            <div className="col-12 py-3">
              <SendMessageChatBox
                isTyping={(typing) => {
                  this.props.isTyping(this.props.currentUser, typing);
                }}
                message={message}
                isSending={isSending}
                sendBtnStatus={sendBtnStatus}
                handleShowFile={() => this.setState({ showFile: true })}
                handleShowLink={() => this.setState({ showLink: true })}
                handleSetMessage={(e) => this.setState({ message: e.target.value })}
                handleSendMessage={this.handleMessage}
              />

              <SendAttachmentModal
                showFile={showFile}
                isSending={isSending}
                attachment={this.state.attachment}
                invalidAttachment={this.state.invalidAttachment}
                handleCancel={() => this.setState({ showFile: false, attachment: null })}
                handleAttachment={this.handleAttachment}
                handleSetAttachment={(attachment) => this.setState({ attachment })}
              />

              <SendLinkModal
                URL={this.state.url}
                showLink={showLink}
                isSending={isSending}
                invalidURL={this.state.invalidURL}
                handleURL={this.handleURL}
                handleSetURL={(e) => this.setState({ url: e.target.value })}
                handleCancel={() => this.setState({ showLink: false })}
              />

              {telehealth && telehealth.hasOwnProperty('carePlan') && (
                <MessageModalCarePlan
                  hide={() => this.setState({ showCarePlan: false })}
                  show={showCarePlan}
                  carePlan={{ carePlan: telehealth.carePlan }}
                  handleClickAttachment={(url) => window.open(url, '_blank')}
                />
              )}
            </div>
          </div>
        </div>
      }
    </div >
  }
}
export default withDataService(Messages)